import { create } from 'zustand';
import { me } from '../api/MemberApi';
import { refresh, logout_server } from '../api/AuthApi';

const useAuthStore = create((set, get) => ({
    member: null,
    isLoading: true,

    checkAuth: async () => {
        // isLoading을 true로 설정하는 부분은 컴포넌트의 useEffect에서 관리
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refreshToken');

        // 1. 토큰이 둘 다 없는 경우
        if (!token && !refreshToken) {
            set({ member: null, isLoading: false });
            return;
        }

        // 2. 액세스 토큰은 없지만 리프레시 토큰이 있는 경우
        if (!token && refreshToken) {
            try {
                const response = await refresh(refreshToken);
                localStorage.setItem('token', response.accessToken);
                localStorage.setItem('refreshToken', response.refreshToken);

                const memberData = await me();
                set({ member: memberData, isLoading: false });
                return;
            } catch (error) {
                get().logout();
                set({ isLoading: false });
                return;
            }
        }

        // 3. 액세스 토큰이 있는 경우
        if (token) {
            try {
                const memberData = await me();
                set({ member: memberData, isLoading: false });
            } catch (error) {
                console.error('멤버 정보 조회 실패:', error);

                // 401 에러의 경우 axios 인터셉터가 처리하므로, 여기서는 모든 경로에서 로딩 상태를 false로 변경
                set({ member: null, isLoading: false });
            }
        }
    },

    setToken: (accessToken, refreshToken) => {
        localStorage.setItem('token', accessToken);
        localStorage.setItem('refreshToken', refreshToken);

        if (window.axios) {
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        }
    },

    setMember: (member) => {
        set({ member: member });
    },

    logout: () => {
        logout_server();
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');

        if (window.axios) {
            delete window.axios.defaults.headers.common['Authorization'];
        }

        set({ member: null, isLoading: false }); // 로그아웃 시에도 로딩 상태 false로 명확히 설정
    },

    refreshMemberInfo: async () => {
        try {
            const memberData = await me();
            set({ member: memberData });
        } catch (error) {
            console.error('멤버 정보 갱신 실패:', error);
        }
    },

    isAuthenticated: () => {
        const state = get();
        const result = !!state.member && !!localStorage.getItem('token');
        return result;
    }
}));

if (typeof window !== 'undefined') {
    window.authStore = useAuthStore.getState();
    useAuthStore.subscribe((state) => {
        window.authStore = state;
    });
}

export default useAuthStore;
